import { render, staticRenderFns } from "./AddNewCompany.vue?vue&type=template&id=92640f6c&"
import script from "./AddNewCompany.vue?vue&type=script&lang=js&"
export * from "./AddNewCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports